//guess we're building charts now

import { type Component, type FunctionalComponent, h } from 'vue'
import { CHART_TYPES } from '@/composables/charts/influx-charts/chart-builders/CHART_TYPES'
import GenericInfluxChart from '@/composables/charts/GenericInfluxChart.vue'
import GenericTimeSeriesChart from '@/composables/charts/GenericTimeSeriesChart.vue'
import GenericChart from '@/composables/charts/GenericChart.vue'
import { InfluxLineChartBuilder } from '@/composables/charts/influx-charts/chart-builders/InfluxLineChartBuilder'
import { CameraBasedInfluxLineChartBuilder } from '@/composables/charts/influx-charts/chart-builders/CameraBasedInfluxLineChartBuilder'
import { RegionInfluxChartBuilder } from '@/composables/charts/influx-charts/chart-builders/RegionChartBuilder'
import { RegionSumInfluxChartBuilder } from '@/composables/charts/influx-charts/chart-builders/RegionSumChartBuilder'
import { IRInfluxChartBuilder } from '@/composables/charts/influx-charts/chart-builders/IRChartBuilder'
import { IncidentBarChartBuilder } from '@/composables/charts/influx-charts/chart-builders/IncidentBarChartBuilder'
import { BaseSerializedChart, SerializedChartType } from '@/composables/charts/influx-charts/chart-builders/ChartInterfaces'
import { DatabaseEntryChartBuilder } from '@/composables/charts/influx-charts/chart-builders/DatabaseEntryChartBuilder'
import { GenericChartBuilder } from '@/composables/charts/influx-charts/chart-builders/GenericChartBuilder'

export function getComponent(serialized: BaseSerializedChart): Component {
  if (serialized.chartType.startsWith('influx')) return GenericInfluxChart
  if (serialized.chartType.startsWith('database.entries')) return GenericTimeSeriesChart
  return GenericChart
}

export function getChartBuilder(
  serialized: BaseSerializedChart
):
  | typeof InfluxLineChartBuilder
  | typeof CameraBasedInfluxLineChartBuilder
  | typeof RegionInfluxChartBuilder
  | typeof RegionSumInfluxChartBuilder
  | typeof IRInfluxChartBuilder
  | typeof IncidentBarChartBuilder
  | typeof DatabaseEntryChartBuilder {
  switch (serialized.chartType) {
    case CHART_TYPES.LINE:
      return InfluxLineChartBuilder
    case CHART_TYPES.CAMERA_BASED_LINE:
      return CameraBasedInfluxLineChartBuilder
    case CHART_TYPES.REGIONS:
      return RegionInfluxChartBuilder
    case CHART_TYPES.REGION_SUMS:
      return RegionSumInfluxChartBuilder
    case CHART_TYPES.IR:
      return IRInfluxChartBuilder
    case CHART_TYPES.INCIDENT_BAR:
      return IncidentBarChartBuilder
    case CHART_TYPES.DATABASE_ENTRIES_BAR:
      return DatabaseEntryChartBuilder
  }
  throw new Error(`Unknown chart type: ${serialized.chartType}`)
}

type ChartBuilderConstructor = new (serialized: SerializedChartType) => GenericChartBuilder

export function assemble(serialized: SerializedChartType): FunctionalComponent {
  const ChartBuilderClass = getChartBuilder(serialized) as unknown as ChartBuilderConstructor
  return (props, { slots }) => {
    return h(getComponent(serialized), { chartBuilder: new ChartBuilderClass(serialized), ...props }, slots)
  }
}
